import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozUnitConversionService} from "../../services/bringoz-unit-conversion.service";

export class PriceBySiteDistanceUnitInputCtrl implements IController {
  value: number;
  formName: string;
  isRequired: boolean;
  isLargeDistance: boolean;
  min:boolean;
  label: string | undefined;
  onChange: Function;

  public siteDistanceUnit: string;

  public shortenCalculatedValue: number;
  public calculatedMin: number;
  public calculatedMax: number;


  /* @ngInject */
  constructor(private splitService, private bringozUnitConversionService: BringozUnitConversionService) {
    this.siteDistanceUnit = splitService.getSiteDistanceSmallUnit();
  }

  $onInit() {

    this.shortenCalculatedValue = !_.isUndefined(this.value) ? (parseFloat(this.priceByDistanceConverter(this.value).toFixed(2))) : undefined;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if ((changes.value)) {
      this.$onInit();
    }
  }

  private priceByDistanceConverter(value: number) {
    return this.isLargeDistance? this.bringozUnitConversionService.pricePerMeterToLargeUnit(value):this.bringozUnitConversionService.pricePerMeterToSmallUnit(value);
  }

  public valueChanged(shortenCalculatedValue) {
    let value = this.isLargeDistance?
      this.bringozUnitConversionService.pricePerLargeSiteUnitToMeter(shortenCalculatedValue):
      this.bringozUnitConversionService.pricePerSmallSiteUnitToMeter(shortenCalculatedValue);

    this.onChange({value: value});
  }

}

angular
  .module('bringoz.admin.commons')
  .component('priceBySiteDistanceUnitInput', {
    require: {
      form: '^form'
    },
    bindings: {
      value: '<',
      isRequired: '<?',
      isLargeDistance: '<?',
      min: '<?',
      label: '<?',
      formName: '@',
      onChange: '&'
    },
    template: require('./price-by-site-distance-unit-input.html').default,
    controller: PriceBySiteDistanceUnitInputCtrl
  });
